import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('commercelayer'),
  experimental: true,
  titleToNamespace: true,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'oauth2',
  avatarPath: avatars.commercelayer,
  logoPath: logos.commercelayer
});
